import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Switch,
  TextField,
  Typography,
  Grid2,
  Paper,
  FormControl,
  IconButton,
  Autocomplete,
  Chip,
  Icon,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialInput from "../../../components/MaterialInput";
import MaterialButton from "../../../components/MaterialButton";
import MaterialSelect from "../../../components/MasterSelect";
import colors from "../../../assest/theme/base/colors";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ClearIcon from "@mui/icons-material/Clear";
import axios from "axios";
import MessagePopup from "../../Utils/MessagePopup";
import ConfirmDialog from "../../Utils/ConfirmDialog";
import { fetchAll, FetchDataGet, postItem, updateItem } from "../../../BaseUrl";
import { GETCLIENT } from "../ClientMaster/Mutation";
import { GETROLE } from "../Role/Mutation";
import countryCodes from "../../countryCodes.json";
import {
  Getalluserdetail,
  Createuserdetail,
  Updateuser,
  GETCLIENTDROPDOWN,
  GetalluserdetailDropdown
} from "../UserMaster/mutation";
import LoadingSpinner from "../../loader/loadercomp";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { UserContext } from "../../usercontext/usercontext";
import MaterialBox from "../../../components/MaterialBox";

const AddUserMaster = ({
  formClose,
  editeddata,
  editedtrue,
  setEditedtrue,
  view,
}) => {
  const { user, isuser } = useContext(UserContext);

  const genderoptions = [
    { label: "Male", value: "Male" },
    { label: "Female", value: "Female" },
    { label: "Others", value: "Others" },
  ];

  const [userdata, setuserdata] = useState({
    firstname: "",
    lastname: "",
    gender: "",
    role: "",
    leader: "",
    clients: "",
    language: "",
    mail: "",
    address: "",
    countrycode: "",
    contactno: "",
    primaryconno: "",
    primarycode: "",
    dob: "",
    dateOfJoining: "",
    dateOfRelieving: "",
    username: "",
    password: "",
    status: "",
    firstnameStatus: "unchecked",
    lastnameStatus: "unchecked",
    genderStatus: "unchecked",
    roleStatus: "unchecked",
    leaderStatus: "unchecked",
    clientsStatus: "unchecked",
    languageStatus: "unchecked",
    mailStatus: "unchecked",
    addressStatus: "unchecked",
    countrycodeStatus: "unchecked",
    contactnoStatus: "unchecked",
    primaryconnoStatus: "unchecked",
    primarycodeStatus: "unchecked",
    dobStatus: "unchecked",
    dateOfJoiningStatus: "unchecked",
    dateOfRelievingStatus: "unchecked",
    usernameStatus: "unchecked",
    passwordStatus: "unchecked",
    statusStatus: "Success",
  });

  const [countryState, setCountryState] = useState({
    countries: [],
    countryCodes: [],
    states: [],
    selectedCountryCode: null,
    selectedCountry: null,
    selectedState: null,
  });
  const [Loader, setLoader] = useState(false);

  const [popup, setPopup] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [dialogOpen, setDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [roleoptions, setroleoptions] = useState([]);
  const [clientoptions, setclientoptions] = useState([]);
  const [useroptions, setuseroptions] = useState([]);
  const [editid, setEditid] = useState(0);
  const [viewPassword, setViewPassword] = useState(false);

  useEffect(() => {
    if (editedtrue === true) {
      getdataforEdit();
    }
  }, [editedtrue]);

  useEffect(() => {
    getClientData();
    getRoleData();
    getcountryoptions();
    // getALluserdetail()
  }, []);

   console.log("userdata.role?.label",userdata.role?.label)
  useEffect(() => {
    let isMounted = true; // Flag to avoid state update if unmounted

    const fetchUserDetails = async () => {
      console.log("userDetails-1")
      if (userdata.role?.label !== undefined) {
      const variables = {
        search: '',
        page: 0,
        pageSize:0,
      };
        try {
          const response = await FetchDataGet(GetalluserdetailDropdown,variables);
          if (response?.getAllCustomUserDetails?.success === true) {
            let filteredUsers = [];
            const userDetails = response.getAllCustomUserDetails.data;
           

            if (
              userdata.role.label === "Team Lead" ||
              userdata.role.label === "Team Leader"
            ) {
              filteredUsers = userDetails.filter(
                (user) =>
                  user.role?.roleName === "Admin" ||
                  user.role?.roleName === "Consultant" // safe access with optional chaining
              );
            } else if (userdata.role.label === "HR") {
              filteredUsers = userDetails.filter(
                (user) =>
                  user.role?.roleName === "Team Lead" ||
                  user.role.roleName === "Team Leader"
              );
            } else if (userdata.role.label === "Recruiters") {
              filteredUsers = userDetails.filter(
                (user) =>
                  user.role?.roleName === "Team Lead" ||
                  user.role.roleName === "Team Leader" ||
                  user.role?.roleName === "Admin" ||
                  user.role?.roleName === "Consultant"
              );
             
            }

            if (isMounted) {
             
              let options = filteredUsers.map((value) => ({
                value: value.id,
                label: value.username,
              }));
              
              setuseroptions(options);
            }
          } else {
            if (isMounted) {
              setuseroptions([]);
            }
          }
        } catch (error) {
          console.error("Failed to fetch user details:", error);
          if (isMounted) {
            setuseroptions([]);
          }
        }
      }
    };

    fetchUserDetails();

    return () => {
      // Cleanup function
      isMounted = false;
    };
  }, [userdata.role]);

  const handleEmailBlur = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    setuserdata((prev) => {
      const isValidEmail = emailRegex.test(prev.mail);

      return {
        ...prev,
        username: isValidEmail ? prev.mail : "",
        usernameStatus: isValidEmail ? "success" : "unchecked",
      };
    });
  };

  const handlePasswordVisibility = () => {
    setViewPassword(!viewPassword);
  };

  const getClientData = async () => {
    try {
        const variables = {
        search: '',
        page: 0,
        pageSize:0,
      };
      if (user?.roleName === "Admin" || user?.roleName === "Consultant") {
        const response = await FetchDataGet(GETCLIENTDROPDOWN,variables);
        if (response?.getAllClients?.success === true) {
          const data = response?.getAllClients?.data.map((v, i) => ({
            value: v?.id,
            label: v?.clientName,
          }));
          setclientoptions(data);
        } else {
          setclientoptions([]);
        }
      } else {
        const res = await FetchDataGet(GetalluserdetailDropdown,variables);
        if (res?.getAllCustomUserDetails?.success === true) {
          let filteredIsUsers = [];
          const userDetails = res.getAllCustomUserDetails.data;

          filteredIsUsers = userDetails.find(
            (item) => item.id === String(isuser.userid)
          );

          let client = filteredIsUsers.clientHandling.map((value) => ({
            value: value.id,
            label: value.clientName,
          }));
          setclientoptions(client);
        } else {
          setclientoptions([]);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const getcountryoptions = () => {
    const phoneOptions = countryCodes.map((item) => ({
      label: item.phone,
      value: item.phone,
    }));
    setCountryState((prevState) => ({
      ...prevState,
      countryCodes: phoneOptions,
    }));
  };

  const getRoleData = async () => {
    try {
      const variables = {
        search: '',
        page: 0,
        pageSize:0,
      };
      const response = await FetchDataGet(GETROLE,variables);
      if (response?.allRoles?.success === true) {
        const role = user?.roleName;
        let data = [];
        if (role === "Team Lead" || role === "Team Leader") {
          data = response?.allRoles?.dataList
            ?.filter((v) => v?.roleName === "Recruiters") // Only keep Recruiter
            ?.map((v) => ({
              value: v?.id,
              label: v?.roleName,
            }));
        } else {
          data = response?.allRoles?.dataList.map((v, i) => ({
            value: v?.id,
            label: v?.roleName,
          }));
        }
        setroleoptions(data);
      } else {
        setroleoptions([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const getdataforEdit = async () => {
    if (!editedtrue) return;

    setEditedtrue(false);
    setIsLoading(true);
    setLoader(true);

    const editedItem = editeddata[0];

    let clientdata = editedItem.clientHandling.map((v, i) => ({
      value: v?.id,
      label: v?.clientName,
    }));

    setTimeout(() => {
      setuserdata({
        ...userdata,
        firstname: editedItem.firstName,
        lastname: editedItem.lastName,
        gender: { label: editedItem.gender, value: editedItem.gender },
        role: { label: editedItem.role.roleName, value: editedItem.role.id },
        leader:
          editedItem.teamLeader != null
            ? {
                label: editedItem.teamLeader.username,
                value: editedItem.teamLeader.id,
              }
            : "",
        clients: clientdata,
        language: editedItem.language,
        mail: editedItem.mailAddress,
        address: editedItem.address,
        countrycode: {
          label: editedItem.countryCode,
          value: editedItem.countryCode,
        },
        contactno: editedItem.contactNumber,
        primaryconno: editedItem.primaryContactNumber,
        primarycode: {
          label: editedItem.primaryCountryCode,
          value: editedItem.primaryCountryCode,
        },
        dob: editedItem.dateOfBirth,
        dateOfJoining: editedItem.dateOfJoining,
        dateOfRelieving: editedItem.dateOfRelieving,
        username: editedItem.username,
        status: editedItem.status,
        firstnameStatus: "success",
        lastnameStatus: "success",
        genderStatus: "success",
        roleStatus: "success",
        leaderStatus: "success",
        clientsStatus: "success",
        languageStatus: "success",
        mailStatus: "success",
        addressStatus: "success",
        countrycodeStatus: "success",
        contactnoStatus: "success",
        primaryconnoStatus: "success",
        primarycodeStatus: "success",
        dobStatus: "success",
        dateOfJoiningStatus: "success",
        dateOfRelievingStatus: "success",
        usernameStatus: "success",
        statusStatus: "success",
      });
      setEditid(editedItem.id);
      // setIsLoading(false);
      setLoader(false);
    }, 1000);
  };

  const handleAddCourseChange = (event, selectEvent) => {
    const changeAllowed = true;
    let formState = { ...userdata };
    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "gender") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "countrycode") {
        const lengthRegex = new RegExp("^.{1,100}$");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "primarycode") {
        const lengthRegex = new RegExp("^.{1,100}$");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "role") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "leader") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }

      formState[selectEvent.name] = event;
    } else {
      switch (event.target.name) {
        case "firstname":
          {
            const alphaNLengthRegex = new RegExp("^[a-zA-Z ]{1,50}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "lastname":
          {
            const alphaNLengthRegex = new RegExp("^[a-zA-Z ]{1,50}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "language":
          {
            const alphaNLengthRegex = new RegExp("^[a-zA-Z ]{1,10}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "mail":
          {
            const alphaNLengthRegex = new RegExp(
              "^[a-zA-Z0-9._%+-]{1,50}@[a-zA-Z0-9.-]+\\.(com|in|org|net|edu|gov|mil|int|co|info|xyz|us|co.uk)$"
            );
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "address":
          {
            const alphaNLengthRegex = new RegExp("^.{1,100}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "contactno":
          {
            const alphaNLengthRegex = new RegExp("^.{1,50}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "primaryconno":
          {
            const alphaNLengthRegex = new RegExp("^.{1,50}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "dob":
        case "dateOfJoining":
        case "dateOfRelieving":
          {
            const alphaNLengthRegex = new RegExp(
              "^[0-9]{4}-[0-9]{2}-[0-9]{2}$"
            );
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "username":
          {
            const alphaNLengthRegex = new RegExp("^.{1,100}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "status":
          // eslint-disable-next-line no-lone-blocks
          {
            if ([true, false].includes(event.target.value)) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "password":
          {
            const alphaNLengthRegex = new RegExp(
              "^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,20}$"
            );
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        default:
          break;
      }
      if (changeAllowed) {
        formState[event.target.name] = event.target.value;
      }
    }
    setuserdata(formState);
  };

  const handleClientChange = (event, newValue) => {
    setuserdata((prevRole) => ({
      ...prevRole,
      clients: newValue,
    }));
  };

  const hanldeConfirmDialogCancel = () => {
    setDialogOpen(false);
  };

  const hanldeConfirmDialogSubmit = async () => {
    try {
      if (editid == 0) {
        const isTeamLeadOrHR =
          userdata.role.label === "Team Lead" ||
          userdata.role.label === "HR" ||
          userdata.role.label === "Recruiters" ||
          userdata.role.label === "Team Leader";
        const variables = {
          input: {
            username: userdata.username,
            // "email": userdata.mail,
            password: userdata.password,
            firstName: userdata.firstname,
            lastName: userdata.lastname,
            gender: userdata.gender.label,
            role: userdata.role.value,
            ...(isTeamLeadOrHR && { teamLeader: userdata.leader.value }),
            clientHandling: userdata.clients.map((item) => parseInt(item.value)),
            language: userdata.language,
            mailAddress: userdata.mail,
            address: userdata.address,
            countryCode: userdata.countrycode.value,
            primaryCountryCode: userdata.primarycode.value,
            contactNumber: userdata.contactno,
            primaryContactNumber: userdata.primaryconno,
            dateOfBirth: userdata.dob,
            // createdBy:user?.id,
            dateOfJoining: userdata.dateOfJoining,
            dateOfRelieving:
              userdata.dateOfRelieving !== "" ? userdata.dateOfRelieving : null,
            status: userdata.status,
          },
        };
        const response = await postItem(Createuserdetail, variables);

        if (response.createCustomUser.success == true) {
          setPopup({
            ...popup,
            open: true,
            message: response.createCustomUser.message,
            severity: "success",
          });
          setDialogOpen(false);
          setTimeout(() => {
            reset();
          }, 1000);
        } else {
          setPopup({
            ...popup,
            open: true,
            message: response.createCustomUser.message,
            severity: "error",
          });
        }
      } else {
        const isTeamLeadOrHR =
          userdata.role.label === "Team Lead" ||
          userdata.role.label === "HR" ||
          userdata.role.label === "Recruiters" ||
          userdata.role.label === "Team Leader";
        const variables = {
          input: {
            id: editid,
            username: userdata.username,
            // "email": userdata.mail,
            firstName: userdata.firstname,
            lastName: userdata.lastname,
            gender: userdata.gender.label,
            role: userdata.role.value,
            ...(isTeamLeadOrHR && { teamLeader: userdata.leader.value }),
            clientHandling: userdata.clients.map((item) => parseInt(item.value)),
            language: userdata.language,
            mailAddress: userdata.mail,
            address: userdata.address,
            countryCode: userdata.countrycode.value,
            contactNumber: userdata.contactno,
            primaryCountryCode: userdata.primarycode.value,
            primaryContactNumber: userdata.primaryconno,
            dateOfBirth: userdata.dob,
            // createdBy:user?.id,
            dateOfJoining: userdata.dateOfJoining,
            dateOfRelieving:
              userdata.dateOfRelieving !== "" ? userdata.dateOfRelieving : null,
            status: userdata.status,
          },
        };
        const response = await updateItem(Updateuser, variables);
        if (response.updateCustomUser.success == true) {
          setPopup({
            ...popup,
            open: true,
            message: response.updateCustomUser.message,
            severity: "success",
          });
          setDialogOpen(false);
          setTimeout(() => {
            reset();
          }, 1000);
        } else {
          setPopup({
            ...popup,
            open: true,
            message: response.updateCustomUser.message,
            severity: "error",
          });
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const handleSubmit = () => {
    setDialogOpen(true);
  };

  const reset = () => {
    setuserdata({
      ...userdata,
      firstname: "",
      lastname: "",
      gender: "",
      role: "",
      leader: "",
      clients: "",
      language: "",
      mail: "",
      address: "",
      countrycode: "",
      contactno: "",
      primaryconno: "",
      primarycode: "",
      dob: "",
      dateOfJoining: "",
      dateOfRelieving: "",
      status: "",
      username: "",
      password: "",
      firstnameStatus: "unchecked",
      lastnameStatus: "unchecked",
      genderStatus: "unchecked",
      roleStatus: "unchecked",
      leaderStatus: "unchecked",
      clientsStatus: "unchecked",
      languageStatus: "unchecked",
      mailStatus: "unchecked",
      addressStatus: "unchecked",
      countrycodeStatus: "unchecked",
      contactnoStatus: "unchecked",
      primaryconnoStatus: "unchecked",
      primarycodeStatus: "unchecked",
      dobStatus: "unchecked",
      dateOfJoiningStatus: "unchecked",
      dateOfRelievingStatus: "unchecked",
      usernameStatus: "unchecked",
      passwordStatus: "unchecked",
      statusStatus: "unchecked",
    });
    formClose();
    setEditid(0);
  };

  const isFormValid = () => {
    if (editid == 0) {
      if (
        userdata.role.label === "Team Lead" ||
        userdata.role.label === "HR" ||
        userdata.role.label === "Recruiters" ||
        userdata.role.label === "Team Leader"
      ) {
        return (
          userdata.firstnameStatus === "success" &&
          userdata.lastnameStatus === "success" &&
          userdata.genderStatus === "success" &&
          userdata.roleStatus === "success" &&
          userdata.leaderStatus === "success" &&
          userdata.clients.length > 0 &&
          userdata.languageStatus === "success" &&
          userdata.mailStatus === "success" &&
          userdata.addressStatus === "success" &&
          userdata.countrycodeStatus === "success" &&
          userdata.contactnoStatus === "success" &&
          userdata.primaryconnoStatus === "success" &&
          userdata.primarycodeStatus === "success" &&
          userdata.dobStatus === "success" &&
          userdata.dateOfJoiningStatus === "success" &&
          userdata.usernameStatus === "success" &&
          userdata.passwordStatus === "success" &&
          userdata.statusStatus === "success"
        );
      } else {
        return (
          userdata.firstnameStatus === "success" &&
          userdata.lastnameStatus === "success" &&
          userdata.genderStatus === "success" &&
          userdata.roleStatus === "success" &&
          userdata.clients.length > 0 &&
          userdata.languageStatus === "success" &&
          userdata.mailStatus === "success" &&
          userdata.addressStatus === "success" &&
          userdata.countrycodeStatus === "success" &&
          userdata.contactnoStatus === "success" &&
          userdata.primaryconnoStatus === "success" &&
          userdata.primarycodeStatus === "success" &&
          userdata.dobStatus === "success" &&
          userdata.dateOfJoiningStatus === "success" &&
          userdata.usernameStatus === "success" &&
          userdata.passwordStatus === "success" &&
          userdata.statusStatus === "success"
        );
      }
    } else {
      if (
        userdata.role.label === "Team Lead" ||
        userdata.role.label === "HR" ||
        userdata.role.label === "Recruiters" ||
        userdata.role.label === "Team Leader"
      ) {
        return (
          userdata.firstnameStatus === "success" &&
          userdata.lastnameStatus === "success" &&
          userdata.genderStatus === "success" &&
          userdata.roleStatus === "success" &&
          userdata.leaderStatus === "success" &&
          userdata.clients.length > 0 &&
          userdata.languageStatus === "success" &&
          userdata.mailStatus === "success" &&
          userdata.addressStatus === "success" &&
          userdata.countrycodeStatus === "success" &&
          userdata.contactnoStatus === "success" &&
          userdata.primaryconnoStatus === "success" &&
          userdata.primarycodeStatus === "success" &&
          userdata.dobStatus === "success" &&
          userdata.dateOfJoiningStatus === "success" &&
          userdata.usernameStatus === "success" &&
          userdata.statusStatus === "success"
        );
      } else {
        return (
          userdata.firstnameStatus === "success" &&
          userdata.lastnameStatus === "success" &&
          userdata.genderStatus === "success" &&
          userdata.roleStatus === "success" &&
          userdata.clients.length > 0 &&
          userdata.languageStatus === "success" &&
          userdata.mailStatus === "success" &&
          userdata.addressStatus === "success" &&
          userdata.countrycodeStatus === "success" &&
          userdata.contactnoStatus === "success" &&
          userdata.primaryconnoStatus === "success" &&
          userdata.primarycodeStatus === "success" &&
          userdata.dobStatus === "success" &&
          userdata.dateOfJoiningStatus === "success" &&
          userdata.usernameStatus === "success" &&
          userdata.statusStatus === "success"
        );
      }
    }
  };

  return (
    <>
      <MessagePopup
        message={popup.message}
        severity={popup.severity}
        open={popup.open}
        setPopup={setPopup}
      />
      {Loader && <LoadingSpinner />}
      <ConfirmDialog
        open={dialogOpen}
        title="Confirm Popup"
        content="Are you sure you want to submit this record?"
        onClose={hanldeConfirmDialogCancel}
        onConfirm={hanldeConfirmDialogSubmit}
      />
      <Box sx={{ p: 3, mx: "auto", borderRadius: 2 }}>
        {/* <Loader isLoading={isLoading} /> */}
        <MessagePopup
          message={popup.message}
          severity={popup.severity}
          open={popup.open}
          setPopup={setPopup}
        />
        <ConfirmDialog
          open={dialogOpen}
          title="Confirm Popup"
          content="Are you sure you want to submit this record?"
          onClose={hanldeConfirmDialogCancel}
          onConfirm={hanldeConfirmDialogSubmit}
        />
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", gap: 4 }}>
            <IconButton onClick={formClose}>
              <ArrowBackIcon sx={{ color: "#000" }} />
            </IconButton>{" "}
            <MaterialTypography
              sx={{ fontSize: "18px", fontWeight: "bold", mt: 2 }}
              mb={2}
            >
              New User
            </MaterialTypography>
          </Box>
          <IconButton onClick={formClose}>
            <ClearIcon sx={{ color: "#000" }} />
          </IconButton>
        </Box>
        <Grid2 container spacing={1.5}>
          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              First Name
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="firstname"
              placeholder="Enter First Name"
              value={userdata.firstname}
              onChange={handleAddCourseChange}
              error={userdata.firstnameStatus === "error" ? true : false}
              success={userdata.firstnameStatus === "success" ? true : false}
              disabled={view}
            />
            {userdata.firstnameStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                First Name must be 1 to 50 Alpha characters.
              </MaterialTypography>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Last Name
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="lastname"
              placeholder="Enter Last Name"
              value={userdata.lastname}
              onChange={handleAddCourseChange}
              error={userdata.lastnameStatus === "error" ? true : false}
              success={userdata.lastnameStatus === "success" ? true : false}
              disabled={view}
            />
            {userdata.lastnameStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                First Name must be 1 to 50 Alpha characters.
              </MaterialTypography>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Gender
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialSelect
              name="gender"
              placeholder={`Select Gender`}
              value={userdata.gender}
              options={genderoptions}
              searchable={false}
              onChange={handleAddCourseChange}
              error={userdata.genderStatus === "error" ? true : false}
              success={userdata.genderStatus === "success" ? true : false}
              isdisabled={view}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Role
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialSelect
              name="role"
              placeholder={`Select Role`}
              value={userdata.role}
              options={roleoptions}
              searchable={false}
              onChange={handleAddCourseChange}
              error={userdata.roleStatus === "error" ? true : false}
              success={userdata.roleStatus === "success" ? true : false}
              isdisabled={view}
            />
          </Grid2>
          {(userdata.role.label == "HR" ||
            userdata.role.label == "Team Lead" ||
            userdata.role.label == "Recruiters" ||
            userdata.role.label == "Team Leader") && (
            <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
                sx={{ color: colors.inputlabel }}
              >
                Admin/Team Leader
                <span style={{ marginLeft: "2px", color: "red" }}>*</span>
              </MaterialTypography>
              <MaterialSelect
                name="leader"
                placeholder={`Select Leader`}
                value={userdata.leader}
                options={useroptions}
                searchable={false}
                onChange={handleAddCourseChange}
                error={userdata.leaderStatus === "error" ? true : false}
                success={userdata.leaderStatus === "success" ? true : false}
                isdisabled={view}
              />
            </Grid2>
          )}

          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Client Handling
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <Autocomplete
              multiple
              id="conducted-select"
              options={clientoptions}
              getOptionLabel={(option) => option?.label || ""}
              value={userdata.clients || []}
              onChange={handleClientChange}
              isOptionEqualToValue={(option, value) => option.value === value.value}
              filterSelectedOptions
              renderTags={(selected, getTagProps) =>
                selected.map((option, index) => (
                  <Chip
                    key={option.id}
                    label={option.label}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField {...params} placeholder="Select Clients" />
              )}
              isdisabled={view}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Language
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="language"
              placeholder="Enter Language"
              value={userdata.language}
              onChange={handleAddCourseChange}
              error={userdata.languageStatus === "error" ? true : false}
              success={userdata.languageStatus === "success" ? true : false}
              disabled={view}
            />
            {userdata.languageStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Language should 1 to 10 Alpha characters.
              </MaterialTypography>
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Mail Address
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="mail"
              placeholder="Enter Mail address"
              value={userdata.mail}
              onChange={handleAddCourseChange}
              onBlur={handleEmailBlur}
              error={userdata.mailStatus === "error" ? true : false}
              success={userdata.mailStatus === "success" ? true : false}
              disabled={view}
            />
            {userdata.mailStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Mail should between 10 to 50 variable characters.
              </MaterialTypography>
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Address
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="address"
              placeholder="Enter Address"
              value={userdata.address}
              rows={4}
              multiline
              onChange={handleAddCourseChange}
              error={userdata.addressStatus === "error" ? true : false}
              success={userdata.addressStatus === "success" ? true : false}
              disabled={view}
            />
            {userdata.addressStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Address should be 1 to 100 variable characters.
              </MaterialTypography>
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Country Code
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialSelect
              name="countrycode"
              placeholder={`Select Country Code`}
              value={userdata.countrycode}
              options={countryState.countryCodes}
              searchable={false}
              onChange={handleAddCourseChange}
              error={userdata.countrycodeStatus === "error" ? true : false}
              success={userdata.countrycodeStatus === "success" ? true : false}
              isdisabled={view}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Contact Number
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="contactno"
              placeholder="Enter Contact Number"
              value={userdata.contactno}
              onChange={(event) => {
                const value = event.target.value;
                if (/^\d{0,10}$/.test(value)) {
                  handleAddCourseChange(event, null); // Call handler only if valid
                }
              }}
              onKeyDown={(event) => {
                const allowedKeys = [
                  "Backspace",
                  "Delete",
                  "ArrowLeft",
                  "ArrowRight",
                  "Tab",
                ];
                const isNumericKey = /^[0-9]$/.test(event.key);
                if (
                  (!isNumericKey && !allowedKeys.includes(event.key)) ||
                  (userdata.contactno &&
                    userdata.contactno.length >= 10 &&
                    isNumericKey)
                ) {
                  event.preventDefault(); // Prevent invalid or extra digits
                }
              }}
              error={userdata.contactnoStatus === "error" ? true : false}
              success={userdata.contactnoStatus === "success" ? true : false}
              disabled={view}
            />
            {userdata.contactnoStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Contact number should be 10 numeric characters.
              </MaterialTypography>
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Primary Country Code
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialSelect
              name="primarycode"
              placeholder={`Select Country Code`}
              value={userdata.primarycode}
              options={countryState.countryCodes}
              searchable={false}
              onChange={handleAddCourseChange}
              error={userdata.primarycodeStatus === "error" ? true : false}
              success={userdata.primarycodeStatus === "success" ? true : false}
              disabled={view}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Primary Contact Number
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="primaryconno"
              placeholder="Enter Contact Number"
              value={userdata.primaryconno}
              onChange={(event) => {
                const value = event.target.value;
                if (/^\d{0,10}$/.test(value)) {
                  handleAddCourseChange(event, null); // Call handler only if valid
                }
              }}
              onKeyDown={(event) => {
                const allowedKeys = [
                  "Backspace",
                  "Delete",
                  "ArrowLeft",
                  "ArrowRight",
                  "Tab",
                ];
                const isNumericKey = /^[0-9]$/.test(event.key);
                if (
                  (!isNumericKey && !allowedKeys.includes(event.key)) ||
                  (userdata.primaryconno &&
                    userdata.primaryconno.length >= 10 &&
                    isNumericKey)
                ) {
                  event.preventDefault(); // Prevent invalid or extra digits
                }
              }}
              error={userdata.primaryconnoStatus === "error" ? true : false}
              success={userdata.primaryconnoStatus === "success" ? true : false}
              disabled={view}
            />
            {userdata.primaryconnoStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Primary Contact number should be 10 numeric characters.
              </MaterialTypography>
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Date of Birth
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="dob"
              placeholder="Enter DOB"
              type="date"
              value={userdata.dob}
              onChange={(e) => {
                const value = e.target.value;
                const dob = new Date(value);
                const today = new Date();
                const age = today.getFullYear() - dob.getFullYear();
                const m = today.getMonth() - dob.getMonth();
                const isBirthdayPassed =
                  m > 0 || (m === 0 && today.getDate() >= dob.getDate());

                const actualAge = isBirthdayPassed ? age : age - 1;

                if (actualAge >= 18 || value === "") {
                  // Only allow setting valid DOB or clearing
                  setuserdata((prev) => ({
                    ...prev,
                    dob: value,
                    dobStatus: "success",
                  }));
                }
                // else: ignore the change (block typing)
              }}
              inputProps={{
                max: new Date(
                  new Date().setFullYear(new Date().getFullYear() - 18)
                )
                  .toISOString()
                  .split("T")[0],
              }}
              disabled={view}
              error={userdata.dobStatus === "error" ? true : false}
              success={userdata.dobStatus === "success" ? true : false}
            />

            {userdata.dobStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                DOB Should be DD-MM-YYYY.
              </MaterialTypography>
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Date of Joining
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="dateOfJoining"
              type="date"
              value={userdata.dateOfJoining}
              onChange={handleAddCourseChange}
              error={userdata.dateOfJoiningStatus === "error" ? true : false}
              success={
                userdata.dateOfJoiningStatus === "success" ? true : false
              }
              disabled={view}
            />
            {userdata.dateOfJoiningStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Date of Joining Should be DD-MM-YYYY.
              </MaterialTypography>
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Date of Relieving
            </MaterialTypography>
            <MaterialInput
              name="dateOfRelieving"
              type="date"
              value={userdata.dateOfRelieving}
              onChange={handleAddCourseChange}
              error={userdata.dateOfRelievingStatus === "error" ? true : false}
              success={
                userdata.dateOfRelievingStatus === "success" ? true : false
              }
              disabled={view}
            />
            {userdata.dateOfRelievingStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Date of Relieving Should be DD-MM-YYYY.
              </MaterialTypography>
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              User Name
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="username"
              placeholder="Enter User Name"
              value={userdata.username}
              onChange={handleAddCourseChange}
              error={userdata.usernameStatus === "error" ? true : false}
              success={userdata.usernameStatus === "success" ? true : false}
              disabled={view}
            />
            {userdata.usernameStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                User Name must between 1-50 Alpha characters.
              </MaterialTypography>
            )}
          </Grid2>
          {editid == 0 && (
            <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
                sx={{ color: colors.inputlabel }}
              >
                Password
                <span style={{ marginLeft: "2px", color: "red" }}>*</span>
              </MaterialTypography>
              <MaterialInput
                name="password"
                type={viewPassword ? "text" : "password"}
                placeholder="Enter Password"
                value={userdata.password}
                onChange={handleAddCourseChange}
                error={userdata.passwordStatus === "error" ? true : false}
                success={userdata.passwordStatus === "success" ? true : false}
                icon={
                  viewPassword
                    ? {
                        direction: "right",
                        component: (
                          <Icon color="action" fontSize="small">
                            <VisibilityOffIcon
                              onClick={handlePasswordVisibility}
                              style={{ cursor: "pointer" }}
                            />
                          </Icon>
                        ),
                      }
                    : {
                        direction: "right",
                        component: (
                          <Icon color="action" fontSize="small">
                            <VisibilityIcon
                              onClick={handlePasswordVisibility}
                              style={{ cursor: "pointer" }}
                            />
                          </Icon>
                        ),
                      }
                }
              />
              {userdata.passwordStatus === "error" && (
                <MaterialTypography
                  variant="caption"
                  color="error"
                  sx={{ mt: 0.5, display: "block" }}
                >
                  Password must between 8-20 characters and should contain At
                  least 1 uppercase letter,1 lowercase letter,1 number, 1
                  special character (like @, !, etc.)
                </MaterialTypography>
              )}
            </Grid2>
          )}

          <Grid2 size={{ xs: 12, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Status
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>

            <MaterialBox sx={{ display: "flex", alignItems: "center", mt: 1 }}>
              <Switch
                checked={userdata.status}
                onChange={(e) =>
                  handleAddCourseChange({
                    target: {
                      name: "status",
                      value: e.target.checked,
                    },
                  })
                }
                color="primary"
                disabled={view}
              />
              <MaterialTypography sx={{ ml: 1 }}>
                {userdata.status === true ? "Active" : "Inactive"}
              </MaterialTypography>
            </MaterialBox>
          </Grid2>

          <Grid2 size={{ xs: 12, md: 12 }}>
            <Box display="flex" justifyContent="space-around" mt={3}>
              {view == false && (
                <MaterialButton
                  variant="contained"
                  sx={{
                    background: colors.buttonColor,
                    color: "#fff",
                    textTransform: "capitalize",
                  }}
                  onClick={handleSubmit}
                  disabled={!isFormValid()}
                >
                  Submit
                </MaterialButton>
              )}
              <MaterialButton onClick={reset} variant="outlined" color="error">
                Cancel
              </MaterialButton>
            </Box>
          </Grid2>
        </Grid2>
      </Box>
    </>
  );
};

export default AddUserMaster;
